import gql from "graphql-tag";

export default {
  mutation: gql`
    mutation addUserRole($roleName: String!, $userId: ID!, $data: JSONString!) {
      addUserRole(
        userId: $userId
        ssoRole: { roleName: $roleName, data: $data }
      ) {
        id
        roleName
        userId
        data
      }
    }
  `,
  mutationName: "addUserRole",
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/ssoUserRole/addUserRole.js